/**
 * Currency conversion helpers.
 *
 * These assume a flat ×100 / 2-decimal currency (e.g. USD, AUD) — the
 * convention already used platform-wide (AM2's `NumericPicker`, the
 * `total_ticket_sales` / `total_donations` BIGINT cents columns, and AM3's
 * own money display). Variable-decimal currencies (JPY has 0 decimals, BHD
 * has 3) are NOT supported by this flat ×100 rule and will be converted
 * incorrectly. Proper variable-decimal support is tracked separately as
 * EC-4302 (under epic EC-4301 "Support multiple currencies").
 */

/**
 * Converts a dollar amount to cents, rounding to the nearest integer.
 *
 * Uses `Math.round`, not `parseInt`/truncation — `parseInt(19.99 * 100)`
 * truncates to `1998` due to floating point error, while `Math.round`
 * correctly gives `1999`.
 */
export function dollarsToCents(dollars: number): number {
  return Math.round(dollars * 100)
}

/**
 * Converts a cents amount back to dollars.
 */
export function centsToDollars(cents: number): number {
  return cents / 100
}
